__turbopack_context__.v({
  "className": "inter_1db00677-module__WhbPaa__className",
});
